/* esm.sh - vfile@6.0.3 */
export * from "/*vfile@6.0.3/esnext/vfile.mjs";
